import { sendEvent } from '$store/sdk/analytics.ts'
import type { AnalyticsEvent } from 'apps/commerce/types.ts'
import { scriptAsDataURI } from 'apps/utils/dataURI.ts'

interface Props<E extends AnalyticsEvent> {
    event: E
}

/**
 * This componente should be used when want to send event for rendered componentes.
 * This behavior is usefull for view_* events.
 */
function SendEventOnLoad<E extends AnalyticsEvent>({ event }: Props<E>) {
    return <script defer src={scriptAsDataURI(sendEvent, event)} />
}

export default SendEventOnLoad
